module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6L8eC"))).then(() => parcelRequire('f4eak'));